import IComponentModal from "react-common-components/dist/components/Modal/interface";

export enum ITypeModal{
    ADD = 1,
    CHANGE = 2,
    VIEW = 3,
    DELETE = 4,
    COPY = 5
}

export interface IModal extends IComponentModal{
    type?: ITypeModal;
}
